import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmbedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Embed",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.5 4.62h-21C3.57 4.62 2 6.19 2 8.12v15.75c0 1.93 1.57 3.49 3.5 3.5h21c1.93 0 3.49-1.57 3.5-3.5V8.11c0-1.93-1.57-3.5-3.5-3.5ZM11.19 19.68a1.119 1.119 0 0 1-.79 1.91c-.31 0-.59-.13-.79-.33l-4.48-4.47c-.2-.2-.33-.48-.33-.79s.13-.59.33-.79l4.48-4.48c.2-.2.48-.33.79-.33s.59.13.79.33.33.48.33.79-.13.59-.33.79L7.5 15.98l3.69 3.69Zm4.41 3.98c-.09.53-.54.93-1.09.93h-.22c-.52-.11-.9-.56-.9-1.1 0-.07 0-.15.02-.22S16.4 8.34 16.4 8.34c.13-.48.57-.82 1.08-.82.62 0 1.12.5 1.12 1.12v.13l-2.99 14.88Zm11.27-6.86-4.48 4.47a1.119 1.119 0 0 1-1.91-.79c0-.31.13-.59.33-.79l3.73-3.73-3.73-3.68a1.119 1.119 0 0 1 .79-1.91c.31 0 .59.13.79.33l4.48 4.48c.22.2.35.49.35.82s-.14.61-.35.82Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21.98 22c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.29-2.29-2.29-2.29a.996.996 0 1 1 1.41-1.41l3 3c.39.39.39 1.02 0 1.41l-3 3c-.2.2-.45.29-.71.29ZM10.02 18c-.26 0-.51-.1-.71-.29l-3-3a.996.996 0 0 1 0-1.41l3-3a.996.996 0 1 1 1.41 1.41L8.43 14l2.29 2.29a.996.996 0 0 1-.71 1.7ZM13.11 22c-.17 0-.34-.04-.5-.13a1.01 1.01 0 0 1-.37-1.37l5.78-10c.28-.48.89-.64 1.37-.37.48.28.64.89.37 1.37l-5.78 10c-.19.32-.52.5-.87.5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27 26H5c-1.65 0-3-1.35-3-3V9c0-1.65 1.35-3 3-3h22c1.65 0 3 1.35 3 3v14c0 1.65-1.35 3-3 3M5 8c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h22c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
      })]
    })
  }));
};